<template>
    <div class="progress-bar">
        <div class="progress-bar__details">
            <div class="progress-bar__details-wrap">
                <span class="label">{{ $t('raised') }}</span>
                <span class="currency">{{currencyProgress}}</span>
            </div>
            <div class="progress-bar__details-wrap">
                <span class="label">{{ $t('goal') }}</span>
                <span class="currency">{{currencyTarget}}</span>
            </div>
        </div>
        <div class="progress-bar__wrap">
            <div class="progress-bar__bar">
                <span class="progress-bar__bar--status" :style="{ width: progression }"></span>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'GoalProgress',

    props: {
      progress: Number,
      percent: Number,
      target: Number
    },

    computed: {
      progression: function () {
        return `${this.percent}%`;
      },
      currencyProgress: function () {
        return this.formatCurrency(this.progress);
      },
      currencyTarget: function () {
        return this.formatCurrency(this.target);
      }
    },

    methods: {
      formatCurrency: function (x) {
        if (x) {
          let parts = (Number.parseFloat(x) / 100).toFixed(2).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return '$' + parts.join('.');
        } else {
          return "$0";
        }
      },
      calcPercentage: function (progress, target) {
        let calc;
        calc = (progress * 100) / target;

        if (isFinite(calc) && !isNaN(calc)) {
          return calc;
        } else {
          return "0";
        }
      }
    }

  }
</script>
